import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const SECTION_PATHS = new Set(["/work", "/projects"]);

function RouteEffects() {
  const { pathname } = useLocation();
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;

  useLayoutEffect(() => {
    document.title =
      path === "/resume" ? "Resume · Max Kotas" : "Max Kotas · Battery Management Systems";

    if (SECTION_PATHS.has(path)) return;
    window.scrollTo(0, 0);
  }, [path]);

  return null;
}

export default RouteEffects;
